<section id="main">
    <div ng-if="vm.step == 1" class="container-fluid cards-container">
        <!-- Account informations -->
        <div ng-if="vm.card" class="account-header-container">

            <!-- Carousel navigation start -->
            <div class="row" data-ng-show="vm.cards.length > 1">
                <ol class="custom-carousel-indicators pull-right">
                    <li data-ng-repeat="account in vm.cards track by $index"
                        data-ng-class="{'active': vm.currentIndex === $index}"
                        data-ng-click="vm.loadCard(account.cardId);"></li>
                </ol>
            </div>

            <div ng-show="vm.isNextButtonVisible" class="pull-right icon-container m-r-15"
                data-ng-click="vm.goToNextItem()">
                <a class="account-navigation-icons">
                    <i class="zmdi zmdi-chevron-right zmdi-hc-4x"></i>
                </a>
            </div>

            <div ng-show="vm.isPreviousButtonVisible" class="pull-left icon-container m-l-15"
                data-ng-click="vm.goToPreviousItem()">
                <a class="account-navigation-icons">
                    <i class="zmdi zmdi-chevron-left zmdi-hc-4x"></i>
                </a>


            </div>
            <!-- Carousel navigation end -->

            <div class="row account-carousel-holder">
                <div class="col-xs-12 account-header-inner float-none">
                    <card-widget card="vm.card"></card-widget>
                </div>
            </div>

        </div>
        <div class="d-flex justify-content-center mt-3">

            <div ng-if="vm.card.cardStatus == 'Inactive' && !vm.card.temporaryStatus" 
                 class="pointer round-btn-container m-b-20">
                <div class="round-btn"><i class="icon icon-credit-card" style="font-size:2em"></i></div>
                <div class="round-btn-label ng-scope" translate="cards.activation"
                     data-ng-click="vm.activateCard();"></div>
            </div>
            <div ng-if="!vm.card.temporaryStatus && !vm.card.changeInProcess"  
                 class="pointer round-btn-container">
                <div class="round-btn"><i class="icon icon-card-settings" style="font-size:2em"></i></div>
                <div class="round-btn-label ng-scope" translate="cards.settings" 
                     data-ng-click="vm.goToCardSettings();">
            </div>
        </div>
    </div>
    <div ng-if="vm.step == 2" class="container-fluid cards-container">
        <card-sign title="cards.authorizationSign" card="vm.card" request="vm.request"></card-sign>
    </div>
</section>